// extracted by mini-css-extract-plugin
module.exports = {"offerText":"offerButton_offerText__u79MJ"};